import { Lottie } from '@alltrails/lottie';
import LogoMorphData from './LogoMorph.json';
import styles from './styles.module.scss';

export default function LogoMorph() {
  return <Lottie animationData={JSON.stringify(LogoMorphData)} autoplay loop className={styles.logo} />;
}
